import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for Ora Cacao's "Vibrant Vitality Cacao - Organic
// Ceremonial Chocolate" (p_6g0aym3i1u), pulled from Faire's live
// `GET /api/product-reviews/product/{product_token}` endpoint (the same data
// source that powers the product's own PDP review list) — verbatim comment,
// real reviewer, real rating, real publish date.
export const review_oc1: FaireReviewEntity = {
  token: "review_oc1",
  type: "review",
  brandName: "Ora Cacao",
  brandToken: "b_djuc44eyt2",
  productToken: "p_6g0aym3i1u",
  reviewType: "product",
  reviewerName: "Deva Munay",
  reviewerLocation: "Big Sur, CA, United States",
  stars: 5,
  reviewText:
    "Wonderful, heart warming cacao!! I am so grateful to have found Ora and to be able to hold the highest vibes in my retreats!",
  reviewDate: "Oct 8, 2024",
  meta: {
    source: "api" as const,
    importedAt: "2026-08-11T20:50:10.000Z",
    importedBy: "entity-db-cli",
  },
};
